import { Row,Col,Image,Stack } from 'react-bootstrap';
import cfIcon from 'Images/public/commenting-tool/CF.png';
import moduleIconH from 'Images/public/commenting-tool/H.png';
import moduleIconDS from 'Images/public/commenting-tool/DS.png';
import moduleIconNH from 'Images/public/commenting-tool/NH.png';
import moduleIconRx from 'Images/public/commenting-tool/Rx.png';
import { commentsMatch, getCommentTempInputData, getErrorList, logS, removeExtrasFromItemNum, validateCommentAPI } from './Util/Utilities';
import { COMMENT_ACTIONS } from './FormData/CommentStateReducer';
import { config } from 'Utils/config';

function EventTypeHeader({ shortName, displayName, categoryId, cfName, moduleHeaderRef, allOpen, setActiveAccordion,  tabActiveKey, tempCommentList, tempCommentListDispatch, commentsListDispatch, commentsList }) {
    
    const getModuleIcon = (id) => {
        switch (true) {
            case (id == 26 || id == 27 || id == 25):
                return moduleIconH;
            case (id == 29):
                return moduleIconDS;
            case (id == 17):
                return moduleIconRx;
            case (id == 28):
                return moduleIconNH;
            default:
                return cfIcon;
        }
    }

    const handleAddToAcc = (newActive) => {
        setActiveAccordion(prev => [...prev, newActive]);
    };
    
    const toggleAll = async (action) => {
        if(action == "expand"){
            setActiveAccordion(allOpen);
        }
        if(action == "collapse"){
            if(tempCommentList!=null){
                const entriesArray = Object.entries(tempCommentList);
                const filteredEntries = entriesArray.filter(([key, value]) => {
                    return (value.status === "add" || value.status === "edit");
                });

                if(Object.entries(filteredEntries).length < 1){
                    setActiveAccordion([]);
                }
                else{ 
                    var change = null;
                    const results = await Promise.all(
                        filteredEntries.map(async entry => {
                            var checkEmpty = null;
                            //console.log(entry);
                            try {
                                var id = entry[0];
                                var value = entry[1];

                                var s = getCommentTempInputData(tempCommentList,id,"status");
                                var d = getCommentTempInputData(tempCommentList,id,"input");
                                const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );
                                //console.log(e);
                                if(s=="edit"){
                                    checkEmpty=true;
                                }
                                else{
                                    checkEmpty=false;
                                }
                                var r = getErrorList(e);
                                var result = {
                                    item: getCommentTempInputData(tempCommentList,id),
                                    errors: r
                                }
                                return result;
                            } catch (err) {
                                console.error(err);
                                return null; // fallback value
                            }
                        })
                    );

                    var expand = [];
                    for(var x = 0 ; x<results.length ; x++){
                        var r = results[x].errors;
                        var item = results[x].item;
                        var id = item.item.id;

                        var s = getCommentTempInputData(tempCommentList,id,"status");
                        var d = getCommentTempInputData(tempCommentList,id,"input");

                        if(r!=null && r.length>0){
                            var arr = [];
                            var isEmpty = false;

                            if(s!=null){
                                if(s=="add"){
                                    for(var x = 0 ; x<r.length ; x++){
                                        if(r[x].code==200){
                                            isEmpty=true;
                                        }
                                        else{
                                            arr.push(r[x].msg);
                                        }
                                    }
                                    if(isEmpty==true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                            id: d.name
                                        });
                                    }
                                    else{
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });

                                        var num = item.item.itemNum;
                                        var numSplit = removeExtrasFromItemNum(num);
                                        for(var x = 1 ; x<=numSplit.length ; x++){
                                            var s = numSplit.slice(0,x);
                                            var joined = s.join(".");
                                            if(x==1){
                                                joined = joined + ".0";
                                            }
                                            expand.push(joined);
                                            handleAddToAcc(joined);
                                        }
                                        
                                        config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.InputRef.current) {
                                            (d.InputRef.current).focus();
                                        }
                                    }
                                }
                                if(s=="edit"){
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: "update-comment-status",
                                            name: id,
                                            status: 'view'
                                        })
                                    }
                                    else{
                                        for(var x = 0 ; x<r.length ; x++){
                                            //console.log(r[x]);
                                            arr.push(r[x].msg);
                                        }
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });

                                        var num = item.item.itemNum;
                                        var numSplit = removeExtrasFromItemNum(num);

                                        for(var x = 1 ; x<=numSplit.length ; x++){
                                            var s = numSplit.slice(0,x);
                                            var joined = s.join(".");
                                            
                                            if(x==1){
                                                joined = joined + ".0";
                                            }

                                            expand.push(joined);
                                            handleAddToAcc(joined);
                                        }
                                        
                                        config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.EditRef.current) {
                                            (d.EditRef.current).focus();
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            if(change==null){
                                change=true;
                            }
                            var i = getCommentTempInputData(tempCommentList,id,"item");
                            
                            if(s!=null){
                                if(s=="add"){
                                    commentsListDispatch({
                                        type: "add-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    });
                                }
                                if(s=="edit"){
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                        commentsListDispatch({
                                            type: "update-comment",
                                            input: d,
                                            item: i,
                                            date: new Date()
                                        })
                                    }
                                }
                            }
                            tempCommentListDispatch({
                                type: "update-comment-status",
                                name: id,
                                status: 'view'
                            })
                        }
                    }
                    setActiveAccordion(expand);
                    config.isDebugEnabled && console.log("%cInitiate - %cAccordion%c - %s", logS.bold, logS.colors.teal, logS.bold,"Collapse All");
                }
            }
        }
            
    } 
    
    return (
        <div className="d-flex flex-column">
            <Col lg={12} className="ct-module-header bg-color-base-white shadow2" ref={moduleHeaderRef}>
                <Row className="g-0 d-flex flex-row flex-nowrap align-items-center">
                    <Col xs={'auto'} md={'auto'}>
                        <Image src={cfIcon} alt="AHRQ Common Formats Logo" width="70" />
                    </Col>
                    <Col xs={11} className="color-primary-capriblue body semilight text-start text-md-center flex-shrink-1 px-3 px-md-5">
                        <span>{displayName}</span>
                    </Col>
                </Row>
                <Row className="g-0 d-flex flex-row flex-nowrap align-items-center bg-color-primary-capriblue">
                    <Col xs={'auto'} md={'auto'}>
                        <Image src={getModuleIcon(categoryId)} alt={cfName + " Logo"} width="70" />
                    </Col>
                    <Col xs={11} className="color-base-white body semilight text-start text-md-center flex-shrink-1 px-3 px-md-5">
                        <span>{shortName!=null ? (shortName).replace(/<br\s*\/?>/gi, ' ') : null}</span>
                    </Col>
                </Row>
                <Stack direction="horizontal" className="mt-3">
                    <button 
                        className="accordion-toggle-all-btn"
                        onClick={()=>{
                            toggleAll("expand");
                        }}
                    >
                        Expand All
                    </button> 
                    <div className="px-1">|</div>
                    <button
                        className="accordion-toggle-all-btn"
                        onClick={()=>{
                            toggleAll("collapse");
                        }}
                    >
                        Collapse All
                    </button>
                </Stack>
            </Col>
        </div>
    );
}

export default EventTypeHeader;